import React from "react";
import { string, func } from "prop-types";
import cx from "classnames";

import TwitterIcon from "../../atoms/icons/twitter";
import FaceBookIcon from "../../atoms/icons/fb";
import WhatsApp from "../../atoms/icons/whatsapp";
import LinkedinIcon from "../../atoms/icons/linkedin";

import "./sticky-social-share.m.css";

class StickySocialShareTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSocialShare: true
    };
  }

  toggleClass = () => {
    this.setState({ showSocialShare: !this.state.showSocialShare });
  };

  render() {
    var socialShare = cx({
      "social-share": true,
      open: this.state.showSocialShare,
      closed: !this.state.showSocialShare
    });
    const { onClick } = this.props;

    return (
      <div styleName="sticky-social-share">
        <ul styleName={socialShare}>
          {/* <li styleName="social-share-icon handle-icon">
            <span onClick={this.toggleClass}>
              {this.state.showSocialShare ? (
                <Close color="#1c1c1c" className="close-icon" />
              ) : (
                <Share color={this.props.color} />
              )}
            </span>
          </li> */}
          <li styleName="social-share-icon">
            <a
              onClick={e => onClick(e)}
              data-social-media-type="twitter"
              href={this.props.twitterUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <TwitterIcon color={this.props.color} />
            </a>
          </li>
          <li styleName="social-share-icon">
            <a
              onClick={e => onClick(e)}
              data-social-media-type="facebook"
              href={this.props.fbUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaceBookIcon color={this.props.color} />
            </a>
          </li>
          <li styleName="social-share-icon">
            <a
              onClick={e => onClick(e)}
              data-social-media-type="linkedin"
              href={this.props.linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedinIcon color={this.props.color} width={24} height={24} />
            </a>
          </li>
          <li styleName="social-share-icon">
            <a
              onClick={e => onClick(e)}
              data-social-media-type="whatsapp"
              href={this.props.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsApp color={this.props.color} width={24} height={24} />
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

StickySocialShareTemplate.propTypes = {
  color: string,
  twitterUrl: string,
  fbUrl: string,
  linkedinUrl: string,
  whatsappUrl: string,
  onClick: func
};

export default StickySocialShareTemplate;
